module.exports = __webpack_public_path__ + "img/bmkfblue.03e2f8cf.png";